module.exports = {
      id: "trash-line-icon-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#trash-line-icon",
      toString: function () {
        return this.url;
      }
    }